'use strict';

angular.module('substoreApp.controllers')
    .controller('productchangeselectionController', ProductchangeselectionController);

function ProductchangeselectionController($scope, $routeParams, dialogData, sessionData, productDataCollector, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts", "#/myproducts");
    $scope.breadcrumb.add("product_change");

    $scope.progressBar.setup({ step: 1 });

    $scope.selection = {
        subscriptionTemplateId: undefined,
        click: function(id) {
            if (id === this.subscriptionTemplateId)
                this.subscriptionTemplateId = undefined;
            else
                this.subscriptionTemplateId = id;
        },
        clicked: function(id) {
            if (id === undefined)
                return (this.subscriptionTemplateId !== undefined);

            return (id === this.subscriptionTemplateId);
        }
    };

    function initDialogData() {
        var data = $scope.data = dialogData;

        var product = productDataCollector.collect(data.oldProduct);
        for (var i = 0; i < data.newProducts.length; i++)
            productDataCollector.collect(data.newProducts[i]);

        htmlTruster.trust(product);
        htmlTruster.trust(data.newProducts);

        $scope.updateTeaser(
            product.texts.headerTitleProductChangeSelection,
            product.texts.headerSubTitleProductChangeSelection,
            product.images.headerImageChangeSelectionResourcePath);

        $scope.footnotes = product.productDescription.footnotes;

        webtrekk.track('productchange_selection', {
            shop_product_name: product.texts.productName,
            shop_product_sku: $routeParams.subscriptionTemplateId
        });
    }

    // configure routing dialog functions
    $scope.nextClicked = false;

    $scope.next = function () {
        if ($scope.nextClicked)
            return;
        $scope.nextClicked = true;

        sessionData.transient.subscriptionTemplateId = $scope.selection.subscriptionTemplateId;

        var nextUrl = "/productchangesummary/"+$scope.data.oldProduct.subscriptionTemplateId+"/"+$scope.data.oldProduct.subscription.uniqueSubscriptionId+"/"+$scope.selection.subscriptionTemplateId;

        $scope.go(nextUrl);
    };

    initDialogData();
}